import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import {
  STORAGE,
  useLocalStorage,
} from '@sorare/core/src/hooks/useLocalStorage';

import { getValidEventType } from 'lib/so5';

export const useLastVisitedEventType = () => {
  const [lastVisitedEventType, setLastVisitedEventType] = useLocalStorage(
    STORAGE.lastVisitedEventType,
    So5FixtureEvent.DAILY.toLowerCase()
  );

  // So lastVisitedEventType is normalized and always in lowercase
  const formattedSetLastVisitedEventType = (
    eventType: So5FixtureEvent | string
  ) => {
    setLastVisitedEventType(eventType.toLowerCase());
  };

  if (
    lastVisitedEventType !==
    getValidEventType(lastVisitedEventType).toLowerCase()
  ) {
    formattedSetLastVisitedEventType(So5FixtureEvent.CLASSIC);
  }

  return {
    lastVisitedEventType,
    setLastVisitedEventType: formattedSetLastVisitedEventType,
  };
};
